module.exports = __webpack_public_path__ + "img/nodejs.ca0c86ef.jpg";